import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import uuid from "react-uuid";
import { makeStyles, withStyles } from "@mui/styles";
import {
  CustomSelect,
  CustomSelectUUID,
  TextInput,
  FloatInput,
  IntInput,
} from "components/Input/Index.js";
import AutocompleteMultiselectInput from "components/Input/AutocompleteMultiselectInput.js";
import AutocompleteTagsInput from "components/Input/AutocompleteTagsInput.js";
import AutocompleteInput from "components/Input/AutocompleteInput.js";
import CreateButton from "components/CustomButtons/CreateButton.js";
import { zone } from "variables/patrimoine.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { walltype } from "variables/lists/patrimoine.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { getFiles, getSite } from "services/ConfigServices";
import { NotificationManager } from 'react-notifications';

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "10%",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "10%",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

function AddWallDialog(props) {
  const [prevData, setPrevData] = useState();
  const [materialList, setMaterialList] = useState([]);

  const [name, setName] = useState("");
  const [clef, setClef] = useState("");
  const [type, setType] = useState("");
  const [materials, setMaterials] = useState([]);
  const [length, setLength] = useState("");
  const [width, setWidth] = useState("");
  const [surface, setSurface] = useState("");
  const [thickness, setThickness] = useState("");
  const [thicknessprecision, setThicknessprecision] = useState("");
  const [walldependency, setWalldependency] = useState("");
  const [deperdition, setDeperdition] = useState("");
  const [uponderation, setUponderation] = useState("");
  const [uwall, setUwall] = useState("");
  const [thermicalresistance, setThermicalresistance] = useState("");
  const [deperditionpart, setDeperditionpart] = useState("");
  const [wallorientation, setWallorientation] = useState("");
  const [rooftilt, setRooftilt] = useState("");
  const [performancegrade, setPerformancegrade] = useState("");
  const [performancecomment, setPerformancecomment] = useState("");
  const [dilapidationgrade, setDilapidationgrade] = useState("");
  const [dilapidationcomment, setDilapidationcomment] = useState("");
  const [otherproperties, setOtherproperties] = useState([]);
  const [associatedfiles, setAssociatedfiles] = useState([]);
  const [comments, setComments] = useState("");
  const [description, setDescription] = useState("");

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const { closeModal, refetch, deleteCounter } = props;

  const handleNameChange = (event) => { setName(event.target.value); };
  const handleClefChange = (event) => { setClef(event.target.value); };
  const handleTypeChange = (event) => { setType(event.target.value); };
  const handleMaterialsChange = (newvalue) => {
    let listtosave = [];
    let listtosaveshort = [];
    let newvalueuuid = [];
    let sumthermicalresistance = 0.0;
    for (let i = 0; i < newvalue.length; i++) {
      newvalueuuid.push(newvalue[i].uuid);
    }
    listtosave = materialList.filter((material) =>
      newvalueuuid.includes(material.uuid)
    );
    listtosave.forEach((element) => {
      listtosaveshort.push({ uuid: element.uuid, name: element.name });
      if (element.thermicalresistance) {
        sumthermicalresistance = sumthermicalresistance + element.thermicalresistance;
      }
    });
    let uwall = 0;
    if (sumthermicalresistance > 0) {
      uwall = Math.round((1 / sumthermicalresistance) * 100) / 100;
    }
    setUwall(uwall);
    setThermicalresistance(sumthermicalresistance);
    setMaterials(listtosaveshort);
  };
  const handleLengthChange = (event) => { setLength(event.target.value); };
  const handleWidthChange = (event) => { setWidth(event.target.value); };
  const handleSurfaceChange = (event) => { setSurface(event.target.value); };
  const handleThicknessChange = (event) => { setThickness(event.target.value); };
  const handleThicknessprecisionChange = (event) => { setThicknessprecision(event.target.value); };
  const handleWalldependencyChange = (event) => { setWalldependency(event.target.value); };
  const handleDeperditionChange = (event) => { setDeperdition(event.target.value); };
  const handleUponderationChange = (event) => { setUponderation(event.target.value); };
  const handleUwallChange = (event) => {
    let uwall = event.target.value;
    let rtherm = 0;
    if (uwall > 0) {
      rtherm = Math.round((1 / uwall) * 100) / 100;
    }
    setUwall(uwall);
    setThermicalresistance(rtherm);
  };
  const handleThermicalresistanceChange = (event) => { setThermicalresistance(event.target.value); };
  const handleDeperditionpartChange = (event) => { setDeperditionpart(event.target.value); };
  const handleWallorientationChange = (event) => { setWallorientation(event.target.value); };
  const handleRooftiltChange = (event) => { setRooftilt(event.target.value); };
  const handlePerformancegradeChange = (event) => { setPerformancegrade(event.target.value); };
  const handlePerformancecommentChange = (event) => { setPerformancecomment(event.target.value); };
  const handleDilapidationgradeChange = (event) => { setDilapidationgrade(event.target.value); };
  const handleDilapidationcommentChange = (event) => { setDilapidationcomment(event.target.value); };
  const handleOtherpropertiesChange = (newvalue) => { setOtherproperties(newvalue); };
  const handleAssociatedfilesChange = (newvalue) => { setAssociatedfiles(newvalue); };
  const handleCommentsChange = (event) => { setComments(event.target.value); };
  const handleDescriptionChange = (event) => { setDescription(event.target.value); };


  const [gedList, setGedList] = useState([
    { fileName: String, fileId: Number },
  ]);
  const selectedGed = () => {
    let gedCardId = [];
    let getGedNames;
    if (associatedfiles !== undefined) {
      for (let i = 0; i < associatedfiles.length; i++) {
        gedCardId.push(associatedfiles[i].fileId);
      }
      getGedNames = gedList.filter((gedList) =>
        gedCardId.includes(gedList.fileId)
      );
    }
    return getGedNames;
  };
  useEffect(() => {
    axios
      .get(
        getFiles(chartIdGroup),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setGedList(res.data.collection);
      });
  }, []);

  useEffect(() => {
    axios
      .get(
        getSite(chartIdGroup, "structure.walls"),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setPrevData(res.data.detail?.structure?.walls?.walls || []);
        setMaterialList(res.data.detail?.structure?.walls?.materials || []);
      });
  }, [deleteCounter]);

  const handleSubmit = async (event) => {
    let walls = prevData;
    const newWall = {
      name,
      clef,
      type,
      materials,
      length,
      width,
      surface,
      thickness,
      thicknessprecision,
      walldependency,
      deperdition,
      uponderation,
      uwall,
      thermicalresistance,
      deperditionpart,
      wallorientation,
      rooftilt,
      performancegrade,
      performancecomment,
      dilapidationgrade,
      dilapidationcomment,
      otherproperties,
      associatedfiles,
      comments,
      description,
      'uuid': uuid(),
    };
    walls.push(newWall);

    axios
      .put(
        getSite(chartIdGroup, "structure.walls.walls"),
        walls,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Paroi ajoutée");
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
        closeModal();
        refetch();
        deleteCounter();
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const autocompleteOptions = [];

  const classes = useStyles();

  return (
    <div>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <TextInput
                inputTitle={zone.structure.walls.walls.key}
                textInput={clef}
                handleTextInputChange={handleClefChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={zone.structure.walls.walls.name}
                textInput={name}
                handleTextInputChange={handleNameChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={zone.structure.walls.walls.type}
                textInput={type}
                handleTextInputChange={handleTypeChange}
              />
            </div>
            <div>
              <IntInput
                inputTitle={zone.structure.walls.walls.length}
                intInput={length}
                handleIntInputChange={handleLengthChange}
              />
            </div>
            <div>
              <IntInput
                inputTitle={zone.structure.walls.walls.width}
                intInput={width}
                handleIntInputChange={handleWidthChange}
              />
            </div>
            <div>
              <IntInput
                inputTitle={zone.structure.walls.walls.surface}
                intInput={surface}
                handleIntInputChange={handleSurfaceChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={zone.structure.walls.walls.thickness}
                floatInput={thickness}
                handleFloatInputChange={handleThicknessChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={zone.structure.walls.walls.thicknessprecision}
                floatInput={thicknessprecision}
                handleFloatInputChange={handleThicknessprecisionChange}
              />
            </div>
            <div>
              <CustomSelectUUID
                inputTitle={zone.structure.walls.walls.walldependency}
                selectValue={walldependency}
                handleSelectValueChange={handleWalldependencyChange}
                data={prevData}
              />
            </div>
            <div style={{ width: "98%" }}>
              <AutocompleteMultiselectInput
                inputTitle={zone.structure.walls.walls.materials}
                selected={materials}
                list={materialList}
                handleChange={handleMaterialsChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={zone.structure.walls.walls.deperdition}
                floatInput={deperdition}
                handleFloatInputChange={handleDeperditionChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={zone.structure.walls.walls.uponderation}
                floatInput={uponderation}
                handleFloatInputChange={handleUponderationChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={zone.structure.walls.walls.thermicalresistance}
                floatInput={thermicalresistance}
                handleFloatInputChange={handleThermicalresistanceChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={zone.structure.walls.walls.uwall}
                floatInput={uwall}
                handleFloatInputChange={handleUwallChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={zone.structure.walls.walls.deperditionpart}
                floatInput={deperditionpart}
                handleFloatInputChange={handleDeperditionpartChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={zone.structure.walls.walls.wallorientation}
                textInput={wallorientation}
                handleTextInputChange={handleWallorientationChange}
              />
            </div>
            <div>
              <FloatInput
                inputTitle={zone.structure.walls.walls.rooftilt}
                floatInput={rooftilt}
                handleFloatInputChange={handleRooftiltChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={zone.structure.walls.walls.performancegrade}
                textInput={performancegrade}
                handleTextInputChange={handlePerformancegradeChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={zone.structure.walls.walls.performancecomment}
                textInput={performancecomment}
                handleTextInputChange={handlePerformancecommentChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={zone.structure.walls.walls.dilapidationgrade}
                textInput={dilapidationgrade}
                handleTextInputChange={handleDilapidationgradeChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={zone.structure.walls.walls.dilapidationcomment}
                textInput={dilapidationcomment}
                handleTextInputChange={handleDilapidationcommentChange}
              />
            </div>

            <div>
              <AutocompleteTagsInput
                inputTitle={zone.structure.walls.walls.otherproperties}
                list={autocompleteOptions}
                selected={otherproperties}
                handleChange={handleOtherpropertiesChange}
              />
            </div>
            <div style={{ width: "98%" }}>
              <AutocompleteInput
                inputTitle={zone.structure.walls.walls.associatedfiles}
                selected={selectedGed()}
                list={gedList}
                handleChange={(_, newValue) =>
                  handleAssociatedfilesChange(newValue)
                }
              />
            </div>
            <div>
              <TextInput
                inputTitle={zone.structure.walls.walls.comments}
                textInput={comments}
                handleTextInputChange={handleCommentsChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={zone.structure.walls.walls.description}
                textInput={description}
                handleTextInputChange={handleDescriptionChange}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
          <CreateButton buttonDisabled={false} handleSubmit={handleSubmit} />
          </GridItem>
        </GridContainer>
      </form>
    </div>
  );
}

export default AddWallDialog;
